import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';

import { agencyDetailLoad } from "store/api/agency";
import { DataLoadComponent } from 'components/common';


class AgencyValue extends DataLoadComponent {
    apiDetailLoad = agencyDetailLoad;

    render() {
        const { id, mode } = this.props;
        const { detail, loadStatus } = this.state;
        const value = (detail && detail.name_en) || id;
        const asLink = mode === 'link';

        return (
            <Spin spinning={loadStatus.isLoading}>
                {asLink ?
                    <Link to={`/agency/${id}`}>{value}</Link>
                    :
                    <span>{value}</span>
                }
            </Spin>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth_token: state.auth.token,
    };
}

export default connect(mapStateToProps)(AgencyValue);
